export default "__VITE_ASSET__D3Xhab$b__"